/**
 * Quote Carousel.
 *
 * Every quote is rendered server-side and stacked; this only moves which one
 * is painted and exposed. Without JS the first quote stays visible and
 * readable, which is why nothing here creates content.
 *
 * Two changes from the prototype: it binds per instance instead of to a
 * hardcoded id, and the arrow-key handler is scoped to each carousel rather
 * than listening on window and measuring the section's bounding box.
 *
 * No optional chaining (?.) or nullish coalescing (??): gulp-babel runs with
 * no preset, so uglify-js parses this as written.
 */
(function () {
  const blocks = document.querySelectorAll(".quote-carousel");
  if (!blocks.length) return;
  function setup(root) {
    const stage = root.querySelector(".qc-stage");
    const quotes = [].slice.call(root.querySelectorAll(".qc-quote"));
    const dots = [].slice.call(root.querySelectorAll(".qc-dot"));
    const prev = root.querySelector(".qc-prev");
    const next = root.querySelector(".qc-next");
    if (quotes.length < 2) return;
    let index = 0;

    // Each quote sizes to its own content (place-items: center does not
    // stretch it to the row), so its offsetHeight is that slide's real
    // height even though the row itself auto-sizes to the tallest one.
    function setStageHeight() {
      if (stage) stage.style.height = quotes[index].offsetHeight + "px";
    }
    function show(i) {
      // Wraps in both directions, so the arrows never dead-end.
      index = (i + quotes.length) % quotes.length;
      quotes.forEach(function (el, n) {
        const on = n === index;
        el.classList.toggle("is-on", on);
        // Keeps the stacked, invisible quotes out of the accessibility tree.
        el.setAttribute("aria-hidden", on ? "false" : "true");
      });
      dots.forEach(function (el, n) {
        el.setAttribute("aria-pressed", n === index ? "true" : "false");
      });
      setStageHeight();
    }

    // Pins the stage to slide 0's height up front, so the first navigation
    // animates from the right baseline instead of from the tallest-quote
    // height the no-JS grid fallback started with.
    setStageHeight();

    // Quote text wraps with the viewport (clamp()/vw sizing, text-wrap:
    // balance), so a resize can change the active slide's own height too.
    let resizeTicking = false;
    window.addEventListener("resize", function () {
      if (resizeTicking) return;
      resizeTicking = true;
      window.requestAnimationFrame(function () {
        setStageHeight();
        resizeTicking = false;
      });
    }, {
      passive: true
    });
    if (prev) prev.addEventListener("click", function () {
      show(index - 1);
    });
    if (next) next.addEventListener("click", function () {
      show(index + 1);
    });
    dots.forEach(function (el) {
      el.addEventListener("click", function () {
        show(parseInt(el.getAttribute("data-i"), 10) || 0);
      });
    });

    // Arrow keys work while focus is anywhere in this carousel's controls,
    // which is the only time they are unambiguous.
    const controls = root.querySelector(".qc-controls");
    if (controls) {
      controls.addEventListener("keydown", function (e) {
        if (e.key === "ArrowLeft") {
          e.preventDefault();
          show(index - 1);
        } else if (e.key === "ArrowRight") {
          e.preventDefault();
          show(index + 1);
        }
      });
    }
  }
  for (let i = 0; i < blocks.length; i++) {
    setup(blocks[i]);
  }
})();